<template>
  <v-toolbar  color="white" class="elevation-0" >
    <v-btn icon  @click="hideFilters">
      <v-icon>close</v-icon>
    </v-btn>
    <v-toolbar-title>Filtros</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <v-btn  flat @click="apply">Limpar</v-btn>
      <v-btn  flat @click="apply">Aplicar</v-btn>
    </v-toolbar-items>
  </v-toolbar>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { EventBus } from '@/services/event-bus';

export default {
  name: 'FilterHeader',
  computed: {
    ...mapGetters({
      filters: 'deposits/filter',
    }),
  },
  methods: {
    hideFilters() {
      EventBus.$emit('layout.deposits.filters.show:false');
    },
    apply() {
      this.$store.dispatch('deposits/load', this.filters);
      EventBus.$emit('layout.deposits.filters.show:false');
    }
  },
};
</script>